import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
const purchases = [{
  name: 'Camille D.',
  city: 'Lyon'
}, {
  name: 'Julien M.',
  city: 'Bordeaux'
}, {
  name: 'Sophie L.',
  city: 'Nantes'
}, {
  name: 'Thomas R.',
  city: 'Lille'
}, {
  name: 'Nathalie P.',
  city: 'Marseille'
}, {
  name: 'Émilie B.',
  city: 'Toulouse'
}, {
  name: 'Sébastien G.',
  city: 'Rennes'
}, {
  name: 'Céline V.',
  city: 'Strasbourg'
}, {
  name: 'Laurent C.',
  city: 'Nice'
}, {
  name: 'Aurélie T.',
  city: 'Montpellier'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 15000);
    const initial = setTimeout(showPopup, 4000);
    return () => {
      clearInterval(interval);
      clearTimeout(initial);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" role="status" aria-live="polite" data-id="element-157" data-mp="22nq32lfvouks">
      <div className="bg-white border-2 border-cta shadow-[0_0_20px_rgba(230,126,34,0.5)] rounded-lg p-2 pr-7 max-w-[275px] w-full relative pointer-events-auto" data-id="element-158" data-mp="1sqv5c4rfiy7k">
        <div className="absolute top-0 left-0 w-full h-1 bg-cta rounded-t" data-id="element-159" data-mp="2lehio4qglh7m" />
        <button onClick={() => setVisible(false)} aria-label="Fermer la notification" className="absolute top-1 right-1 text-ink/50 hover:text-ink transition-colors" data-id="element-160" data-mp="2lcejau3f2bq8">
          <XIcon className="w-3.5 h-3.5" data-id="element-161" data-mp="2cg5knhn9jh55" />
        </button>
        <div className="flex items-center gap-2.5 mt-1" data-id="element-162" data-mp="1510tnqiujfow">
          <div className="w-8 h-8 rounded-full bg-petrol flex items-center justify-center shrink-0" data-id="element-163" data-mp="10yw4b3zfl582">
            <ShoppingBagIcon className="w-4 h-4 text-white" data-id="element-164" data-mp="12g2xmhzug9mt" />
          </div>
          <div className="leading-tight" data-id="element-165" data-mp="12dyva4hlfion">
            <p className="font-heading font-bold text-navy text-[13px]" data-id="element-166" data-mp="17f5yrrcpdvpi">
              {current.name} — {current.city}, France
            </p>
            <p className="text-[11px] text-petrol font-semibold" data-id="element-167" data-mp="sjq3xk4atvs2">
              vient d'acheter SENIOR FITNESS PRO™
            </p>
          </div>
        </div>
      </div>
    </div>;
}